import { useParams, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import eventsData from "../events.json";

const toKey = (s) => {
    // s puede ser "dd-mm-yy", "dd-mm", o "dd-mm-yyyy"
    if (!s) return Number.MAX_SAFE_INTEGER;
    const parts = s.split("-");
    if (parts.length === 3) {
      const [dd, mm, yyRaw] = parts;
      const yyyy = yyRaw.length === 2 ? `20${yyRaw}` : yyRaw; // maneja 2 o 4 dígitos
      return Number(`${yyyy}${mm}${dd}`); // ej: 20260514 -> 20260514
    }
    if (parts.length === 2) {
      // dd-mm → asumí año actual (2 dígitos)
      const yy = new Date().getFullYear().toString().slice(-2);
      const [dd, mm] = parts;
      return Number(`20${yy}${mm}${dd}`);
    }
    return Number.MAX_SAFE_INTEGER;
  };
  

const inferOrdenFecha = (event) => {
  // usa "orden-fecha" si existe; si no, intenta con "date"
  if (event["orden_fecha"]) return toKey(event["orden_fecha"]);
  return toKey(event.orden_fecha);
};

const TourDetail = () => {
  const { band } = useParams();
  const navigate = useNavigate();

  const tourEvents = useMemo(() => {
    const filtered = eventsData.filter((e) => e.band === band);
    return filtered.slice().sort((a, b) => inferOrdenFecha(b) - inferOrdenFecha(a));

  }, [band]);

  if (tourEvents.length === 0) {
    return (
      <section className="page-section" id="tour-detail">
        <div className="container">
          <div className="text-center">
            <h1>Gira no encontrada</h1>
            <button className="btn btn-primary mt-3" onClick={() => navigate("/")}>
              Volver al inicio
            </button>
          </div>
        </div>
      </section>
    );
  }

  const tour = tourEvents[0];

  return (
    <section className="page-section" id="tour-detail">
      <div className="container">
        <div className="text-center mb-4">
          <h1 className="display-4">{tour.band_name}</h1>
          <h2 className="text-muted">{tour.tour_name}</h2>
          <div className="text-center mt-4">
            <button className="btn btn-secondary" onClick={() => navigate("/")}>
              ← Volver al inicio
            </button>
          </div>
          <p className="lead mt-3">
            <strong>{tourEvents.length}</strong> fechas confirmadas
          </p>
        </div>

        <div className="row justify-content-center">
          {tourEvents.map((event, index) => (
            <div key={index} className="d-flex flex-column px-3 align-items-center" id="flyer">
              <img src={event.src} alt={event.alt} width={350} height={350} />
              <div className="text-center mt-3">
                <h5>{event.lugar}</h5>
                <p className="text-muted mb-1">{event.venue}</p>
                <p className="text-white">
                  <strong>{event.fecha}</strong>
                </p>
              </div>
              {event.url && (
                <button
                  type="button"
                  className="btn"
                  id="boton-inicio"
                  onClick={() => (window.location.href = event.url)}
                >
                  Comprar tickets
                </button>
              )}
              <hr />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TourDetail;
